import React from "react"
import colors from "../../config/colors.js"
import styled from "styled-components"

const NavItem = styled.li`
  background-color: ${props => (props.active ? colors.secondaryDark : colors.primaryDark)};
`

export default NavItem



// WEBPACK FOOTER //
// ./src/components/NavItem/index.js